import { render, staticRenderFns } from "./forbidden.vue?vue&type=template&id=52bf3a40&scoped=true"
import script from "./forbidden.vue?vue&type=script&lang=js"
export * from "./forbidden.vue?vue&type=script&lang=js"
import style0 from "./forbidden.vue?vue&type=style&index=0&id=52bf3a40&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bf3a40",
  null
  
)

export default component.exports